import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ISendEmailCredential } from '@app-store/slices/emails/sendEmail'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: ISendEmailCredential
}

const { onRequest, onSuccess, onFailure } = rootActions.emails.sendEmail

function* sendEmailSaga({ payload }) {
    try {
        const response = yield axios.post(`/notifications/emails`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Email has been sent successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* createEventCampaignSaga(): any {
    yield takeLatest<TaskAction>(onRequest, sendEmailSaga)
}

export default createEventCampaignSaga
